import React from 'react';
import { ListSVG } from '../../@common_components/svgs/list.svg';

type ListIconProps = { active?: boolean } & React.SVGProps<SVGSVGElement>;

const ListIcon: React.FC<ListIconProps> = ( props: ListIconProps ) => {
  const { active, ...restProps } = props;
  const classes = `w-5 h-5 fill-current ${ active ? 'text-red-500' : 'text-gray-400' }`;
  return <ListSVG {...restProps} className={ classes } />;
};

export { ListIcon };
